export const environment = {
  production: false,
  apiUrl: 'https://hml-api-backoffice.evnt.com.br/api/v1',
};
